<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
      <app-side-nav [item]="meetingNav"></app-side-nav>
  </div> -->
  <div class="col-12 p-0 book-confirm">
    <!-- <app-header></app-header> -->
    <div class="col-height">
      <div class="row padding-cls">
        <div class="breadcrumbs-section">
          <span class="curr-page pr-1 breadcrumbs-individual">Home</span>
          <span class="separator">&nbsp; > &nbsp;</span>
          <span class="curr-page pr-1 breadcrumbs-individual"><a
              routerLink="/meeting/meetingroom-list">Meetings</a></span>
          <span class="separator">&nbsp; > &nbsp;</span>
          <span class="curr-page pr-1 breadcrumbs-individual"><a
              routerLink="/meeting/meetingroom-list/bookmeetingroom">Book a meeting room</a></span>
          <span class="separator">&nbsp; > &nbsp;</span>
          <span class="curr-page pl-1 breadcrumbs-individual">Booking Confirmed!</span>
        </div>
      </div>

      <div class="row padding-cls">
        <div class="flex-fill">
          <img [src]="meetingRoomImage" style="width:100%;object-fit: cover;height: 320px;border-radius: 10px;"
            loading="lazy" />

        </div>
      </div>
      <div class="bkg_tab">
        <div class="ord_tab">
          <div *ngIf="meetingStatus == 'Active'" class="row">
            <div class="col-sm-1 align-self-center">
              <img src="/assets/images/green-tick.png" loading="lazy" />
            </div>
            <div class="col-sm-10 ord-tab_txt">
              <span class="booking-confirmed"> Booking Confirmed </span>
              <span class="you-are-all-set-for"> You are all set for next meeting</span>
            </div>
          </div>
          <div *ngIf="meetingStatus == 'Cancelled'" class="row">
            <div class="col-sm-1" style="padding-left: 60px;">
              <img src="/assets/images/cancel-icon.png" loading="lazy" />
            </div>
            <div class="col-sm-10 ord-tab_txt">
              <span class="cancelled"> Cancelled on {{meetingCancelledDate}} </span>
              <span class="you-are-all-set-for"> We have informed your meeting invitees</span>
            </div>
          </div>
        </div>
        <div class="hf_crcl-area">
          <div class="row">
            <div class="col-sm-6">
              <span class="hf-circle"> </span>
            </div>
            <div class="col-sm-6 text-right pr-0">
              <span class="hf-circle-right"> </span>
            </div>

          </div>
          <hr class="hrline">
        </div>
        <div class="btm-tab">
          <p class="adv"
            style="color: rgba(64,64,64,0.6);font-family: Montserrat;font-size: 16px;font-weight: 600;letter-spacing: 0;line-height: 19px;margin-left: 25px;">
            {{meetingRoomName}} ( {{noOfPax}} PAX )</p>
          <div class="row4">
            <ul class="lst">
              <li>
                <img src="/assets/images/calendar-3.png" style="margin-bottom: 5px;" loading="lazy" />
                <span class="txt1"
                  style="margin-left: 12px;height: 24px;width: 140px;color: #404040;font-family: Montserrat-bold;font-size: 20px;font-weight: bold;letter-spacing: 0;line-height: 24px;">{{
                  convertDateFormat(meetingDate)}}</span>
              </li>
              <li>
                <img src="/assets/images/black-clock.png" style="margin-bottom: 5px;" loading="lazy" />
                <span class="txt1"
                  style="margin-left: 12px;height: 24px;width: 140px;color: #404040;font-family: Montserrat-bold;font-size: 20px;font-weight: bold;letter-spacing: 0;line-height: 24px;">
                  {{fromTime}} - {{toTime}}</span>
              </li>
              <li>
                <img src="/assets/images/stopwatch-black.png" style="margin-bottom: 5px;" loading="lazy" /><span
                  class="txt1"
                  style="margin-left: 12px;height: 24px;width: 140px;color: #404040;font-family: Montserrat-bold;font-size: 20px;font-weight: bold;letter-spacing: 0;line-height: 24px;">
                  {{duration}} hour(s)</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <br>
      <div class="row padding-cls2" style="margin-right: 7%;height: 70px;">
        <div class="col-6" style="">
          <p class="invite-header">Employees</p>
          <p class="invite-header-member">{{meetingAttendees.length}} of {{noOfPax}} Members</p>
        </div>
        <div class="col-6" style="padding-left: 27%;">
          <button type="button" class="btn btn-info"
            style="width: 180px;border-radius: 10px;background-color: #1DA5B3;height: 50px;" (click)="openXl(content)"
            [disabled]="meetingStatus == 'Cancelled' || meetingStatus == 'expired'">
            <p class="btn-text">Invite Member(s)</p>
          </button>
        </div>
      </div>

      <div style="height: 200px; " class="layout-height c2 scroll-position" *ngIf="meetingAttendees.length!= 0">
        <div class="row padding-cls2 " *ngFor="let attendees of meetingAttendees"
          style="/* margin-top: -3%; */margin-right: 7%;height: 70px;"
          style="background-color: #fafafa;border-radius: 10px;height: 82px;margin-top: 10px;margin-bottom: 10px;">
          <div class="col-1" style="padding-left: 6%;padding-top:20px;">
            <img *ngIf="attendees?.image!=null && attendees.image!=''" class="person-image" [src]="attendees?.image"
              loading="lazy" />
            <!-- <img *ngIf="attendees?.image!=null && attendees.image!=''" class="person-image" style="height: 45%;"
              [src]="attendees?.image" loading="lazy" /> -->

            <img *ngIf="attendees.image==null || attendees.image==''" class="person-image"
              src="/assets/images/DefaultUserImg.png" loading="lazy" />
          </div>
          <div class="col-9">
            <div class="row" style="padding-top: 17px;padding-left: 45px;">
              <div class="col-12" class="popup-invite-member-name">{{attendees.fullName}}</div>
            </div>
            <div class="row" style="padding-left: 45px;">
              <div class="col-12" class="popup-invite-member-email">{{attendees.emailAddress}}</div>
            </div>

          </div>
          <div class="col-2" style="padding-top: 28px;">
            <p *ngIf="meetingStatus == 'Active' && attendees.isActive==false" class="remove-btn"
              [disabled]="(meetingStatus == 'Cancelled' || meetingStatus == 'expired')"
              (click)="RemoveMemberFromMeeting(attendees)">Remove
            </p>
          </div>
        </div>
      </div>
      <br>
      <div class="row padding-cls" style="border-top: 1px solid #e5e5e5;padding-top: 15px;">
        <div class="col-9 cancellation-header">
          <p>Cancellation Policies</p>
        </div>
        <div class="col-2 ml-2 cancel-booking">
          <button type="button" style="border: none;background-color: white;"
            [disabled]="meetingStatus == 'Cancelled' || meetingStatus == 'expired'" (click)="CancelBooking()">
            <p class="cancel-booking">Cancel Booking</p>
          </button>
        </div>
      </div>
      <br>
      <div class="row padding-cls">
        <div class="col-12">
          <p class="ul-header">Bridge+ Member</p>
          <ul>
            <li class="li-item">Cancellation of bookings for meeting services must be made at least 15 minutes before
              the time slot requested. Otherwise, no refund would be made for the Meeting Service Credits.</li>
            <li class="li-item">Upon completion of the booking via Bridge+ Members, service credits will be deducted.
            </li>
          </ul>
        </div>
      </div>
      <div class="row padding-cls">
        <div class="col-12">
          <p class="ul-header">Bridge+ Non-Member</p>
          <ul>
            <li class="li-item">Cancellation of bookings for meeting services must be made at least 15 minutes before
              the time slot requested. Otherwise, no refund would be made for the Meeting Service Credits.</li>
            <li class="li-item">Upon completion of the booking via Bridge+ Members, service credits will be deducted.
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- <app-footer></app-footer> -->
    </div>
  </div>
</div>
<ng-template #content let-modal>
  <div *ngIf="!showExternalDetails">
    <div class="" style="height: 30px;">
      <div class="col-1" style="position:absolute; right:0;margin-top: 8px;">
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"
          style="padding-right: 10px;">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="row" style="margin-top:14px;padding-left:40px">
      <div class="col-10">
        <span class="popup-header">Invite Members</span>
      </div>
      <div class="col-2 pl-0 pr-0">
        <button type="button" style="border: none;background-color: white;">
          <p class="popup-add-member-btn" (click)="onClickAddMember()">Add Member</p>
        </button>
      </div>
    </div>
    <div class="" style=" padding-bottom: 2%;display: flex;">
      <img src="/assets/images/search.png" class="" loading="lazy"
        style="position: absolute;padding-top: 1.5rem;padding-left: 0.75rem;" />
      <input type="text" class="placeholder-class" placeholder="Type here to search" [(ngModel)]="searchtext"
        style="width: 100%;height: 4rem;border: 1px solid #D7D7D7;text-indent: 3rem;outline: none;color: rgba(64,64,64,0.6);font-family: Montserrat;font-weight: 600;">
    </div>
    <div class="layout-height c2 scroll-position">
      <div class="row" *ngFor="let item of items | filterText : searchtext"
        style="background-color: #fafafa;border-radius:9px;margin-left: 2%;margin-right: 2%;height: 82px;margin-bottom: 1%;">
        <div class="col-2" style="padding-left: 6%;padding-top:20px;">
          <img *ngIf="item?.image!=null && item.image!=''" class="person-image" [src]="item.image" loading="lazy" />

          <img *ngIf="item.image==null || item.image==''" class="person-image" src="/assets/images/DefaultUserImg.png"
            loading="lazy" />
        </div>
        <div class="col-8">
          <div class="row" style="margin-top: 20px;">
            <span class="popup-invite-member-name">{{item.fullName}}</span>
          </div>
          <div class="row">
            <span class="popup-invite-member-email">{{item.emailAddress}}</span>
          </div>
        </div>
        <div class="col-2" style="padding-top: 28px;padding-left: 70px;">
          <label class="c-container">
            <input type="checkbox" [checked]="item.selected" (change)="OnCheckBoxChange(item)" [value]="item.selected">
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="popup-footer">
      <span class="popup-members-selected" style="position: absolute;padding-top: 15px;">{{totalSelected}} of
        {{items.length}} Members Selected</span>
      <button type="button" class="btn popup-send-invite-btn" [disabled]="this.totalSelected == 0"
        (click)="onClickSendInvite()">
        <p class="popup-send-invite-btn-text">Send Invite</p>
      </button>
    </div>
  </div>

  <div *ngIf="showExternalDetails">
    <div class="row" style="margin-left: 6%;height: 3rem;margin-top: 1rem;">
      <div class="col-1 pr-0">
        <img src="/assets/images/back.png" class="" (click)="onClickBack()" loading="lazy" />
      </div>
      <div class="col-10 pr-0 pl-0">
        <span
          style="height: 24px;width: 134px;color: #404040;font-family: Montserrat-bold;font-size: 20px;font-weight: bold;letter-spacing: -0.24px;line-height: 24px;">Add
          Member</span>
      </div>
      <div class="col-1">
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"
          style="padding-right: 35px;">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-5" style="padding-left: 5%;padding-right: 4%;">
        <div class="row" style="margin-top: 1%;margin-bottom: 5%;">
          <span class="lbl-cls"> First Name</span>
          <input type="text" class="txt-cls" [(ngModel)]="entity.firstName"
            (ngModelChange)="inputModelChange('firstName')"
            [class.error-input]="fieldErrors.includes('fnameEmpty') || fieldErrors.includes('firstName')"
            (click)="enterName('firstName')" (keypress)="keyPressAlphaNumbersDecimal($event)" name="firstName"
            pattern="^[a-zA-Z ]{2,30}$" required>
          <div *ngIf="fieldErrors.length > 0" class="col-12 field-error">
            <span *ngIf="fieldErrors.includes('fnameEmpty')">Please enter first name</span>
            <span *ngIf="fieldErrors.includes('firstName') && !fieldErrors.includes('fnamelen')">
              Please enter valid name</span>
            <span *ngIf="fieldErrors.includes('fnamelen')">
              Please enter not more than 30 characters</span>
          </div>
        </div>
        <div class="row" style="margin-top: 1%;margin-bottom: 5%;">
          <span class="lbl-cls"> Email ID</span>
          <input type="text" class="txt-cls" [(ngModel)]="entity.emailAddress"
            [class.error-input]="fieldErrors.includes('emailEmpty') || fieldErrors.includes('email')"
            (click)="enterName('email')" name="emailId" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
            required>
          <div *ngIf="fieldErrors.length > 0" class="col-12 field-error">
            <div *ngIf="fieldErrors.length > 0" class="col-12 field-error">
              <span *ngIf="fieldErrors.includes('emailEmpty')">Please enter email</span>
              <span *ngIf="fieldErrors.includes('email')">Please enter valid email</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-5" style="padding-left: 4%;padding-right: 5%;">
        <div class="row" style="margin-top: 1%;margin-bottom: 5%;">
          <span class="lbl-cls"> Last Name</span>
          <input type="text" class="txt-cls" [(ngModel)]="entity.lastName"
            (ngModelChange)="inputModelChange('lastName')"
            [class.error-input]="fieldErrors.includes('lnameEmpty') || fieldErrors.includes('lastName')"
            (click)="enterName('lastName')" (keypress)="keyPressAlphaNumbersDecimal($event)" name="lastName"
            pattern="^[a-zA-Z ]{2,30}$" required>
          <div *ngIf="fieldErrors.length > 0" class="col-12 field-error">
            <span *ngIf="fieldErrors.includes('lnameEmpty')">Please enter last name</span>
            <span *ngIf="fieldErrors.includes('lastName') && !fieldErrors.includes('lnamelen')">Please enter valid
              name</span>
            <span *ngIf="fieldErrors.includes('lnamelen')">Please enter not more
              than 30 characters</span>
          </div>
        </div>
        <div class="row" style="margin-top: 1%;margin-bottom: 5%;">
          <span class="lbl-cls"> Mobile Number</span>
          <span class="prefix">+91</span>
          <input type="text" class="txt-cls-mob" [(ngModel)]="entity.phoneNumber"
            [class.error-input]="fieldErrors.includes('phone')" (click)="enterName('mobile')"
            (keyup)="inputModelChange('phone')" name="phoneNumber" placeholder="Optional" required>
          <div class="row" *ngIf="fieldErrors.length > 0">
            <div class="col-12 field-error">
              <span *ngIf="fieldErrors.includes('phone')">Please enter valid
                mobile number</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2">
        <div class="row">
          <img src="/assets/images/profile/default-user.png" class="" loading="lazy" />
        </div>
      </div>
    </div>
    <div class="popup-footer">
      <button type="submit" class="btn popup-send-invite-btn">
        <!-- [disabled]="!entity.firstName ||  !entity.lastName || !entity.emailAddress"> -->
        <p class="popup-send-invite-btn-text" (click)="onClickAdd($event)">Add</p>
      </button>
    </div>
  </div>
</ng-template>
